import footer from './footer.layout';

export default footer;
